module.exports = __webpack_public_path__ + "static/media/telefon.2979bdfb.svg";